<template>
  <div
    id="pageusers"
    :class="{
      'mx-0 mt-1': $vuetify.breakpoint.xs,
      'mx-3 mt-1': $vuetify.breakpoint.smAndUp,
    }"
  >
    <v-card>
      <v-layout row wrap class="ma-0" v-if="!pageLoading">
        <v-flex xs12 sm6 pt-3>
          <addBtn
            :text="lang.add_user"
            :disabled="pageLoading"
            @click="addDialog = true"
          ></addBtn>
          <!--           
        <v-btn color="secondary" text @click="viewCharts()" :disabled="pageLoading">
          <v-icon left class="fal fa-chart-bar" small></v-icon>
          {{lang.user_statistics}}
          </v-btn>-->
          <v-btn
            :block="$vuetify.breakpoint.xs"
            color="secondary"
            text
            @click="refreshUsers"
            :disabled="pageLoading"
          >
            <v-icon left class="fa-light fa-arrows-rotate" small></v-icon>
            {{ lang.refresh }}
          </v-btn>
        </v-flex>
        <v-flex xs12 sm6 px-4 pb-3>
          <v-text-field
            v-model="search"
            append-icon="search"
            label="Search"
            single-line
            hide-details
          ></v-text-field>
        </v-flex>
      </v-layout>
      <v-skeleton-loader v-if="pageLoading" type="table"></v-skeleton-loader>
      <v-data-table
        v-else
        :headers="headers"
        :items="allusers"
        :search="search"
        item-key="UID"
      >
        <template slot="item" slot-scope="props" v-if="props.item != null">
          <tr>
            <td>
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-btn
                    text
                    icon
                    v-on="on"
                    v-clipboard:copy="props.item.Email"
                    v-clipboard:success="onCopy"
                    v-clipboard:error="onError"
                  >
                    <v-icon>flip_to_front</v-icon>
                  </v-btn>
                </template>
                <span>{{ lang.copy }} {{ lang.email }}</span>
              </v-tooltip>
              <v-btn
                text
                class="primary--text no-uppercase"
                @click="openUser(props.item.Email)"
                >{{ props.item.Email }}</v-btn
              >
            </td>
            <td align="center" :class="[props.item.status ? '' : 'red--text']">
              {{ props.item.status ? lang.active : lang.disabled }}
            </td>
            <td align="center">
              <v-edit-dialog
                :ref="props.item.Email"
                :return-value.sync="props.item.accountName"
                @save="updateUser(props.item)"
              >
                {{ props.item.accountName }}
                <v-icon small class="ml-2">fa-light fa-pen</v-icon>
                <template v-slot:input>
                  <v-text-field
                    v-model="props.item.accountName"
                    :rules="nameRules"
                    :label="lang.account_name"
                    single-line
                    append-icon="fa-light fa-floppy-disk"
                    @click:append="
                      $refs[props.item.Email].save(props.item.accountName);
                      updateUser(props.item);
                    "
                    clearable
                  ></v-text-field>
                </template>
              </v-edit-dialog>
            </td>

            <td align="center">{{ props.item.location.country_name }}</td>
            <td align="center">{{ props.item.players || 0 }}</td>
            <td align="center">
              <span class="green--text">{{
                props.item.onlinePlayers || 0
              }}</span>
              /
              <span class="red--text">{{
                props.item.offlinePlayers || 0
              }}</span>
            </td>
            <td align="center">{{ props.item.licenses || 0 }}</td>
            <td align="center">
              <v-btn
                text
                icon
                @click="confirmUserDelete(props.item.Email)"
                color="primary"
              >
                <v-icon small class="fa-light fa-xmark red--text"></v-icon>
              </v-btn>
            </td>
          </tr>
        </template>
        <v-alert slot="no-results" :value="true" color="error" icon="warning"
          >Your search for "{{ search }}" found no results.</v-alert
        >
      </v-data-table>
      <v-dialog persistent v-model="manageDialog" fullscreen hide-overlay>
        <v-card class="bg">
          <manage
            :email="manageEmail"
            v-if="manageEmail != ''"
            @dialog="
              manageDialog = false;
              manageEmail = '';
            "
          />
        </v-card>
      </v-dialog>
      <v-dialog persistent v-model="chartsDialog" fullscreen hide-overlay>
        <v-card class="bg">
          <charts :users="allusers" @dialog="chartsDialog = false" />
        </v-card>
      </v-dialog>
      <v-snackbar
        v-model="showAlert"
        :color="color"
        :multi-line="true"
        :right="true"
        :timeout="timeout"
        :top="true"
      >
        <v-icon large color="white">{{ icon }}</v-icon>
        {{ alertMessage }}
      </v-snackbar>
      <addUser :dialog="addDialog" @close="addDialog = false" />
      <dialogConfirm
        :dialog="deleteConfirm"
        :title="lang.deleteConfirm"
        :msg="lang.deleteMsgUser + currentUserId + '?'"
        @onConfirm="deleteUser()"
        @onCancel="deleteConfirm = false"
      />
    </v-card>
  </div>
</template>

<script>
import { mapState } from "vuex";
import manage from "./manage/Manage.vue";
import addUser from "./add_user";
import dialogConfirm from "@/components/dialogConfirm";
import addBtn from "@/components/addBtn";
const users = require("./users.js").users;
import charts from "./charts/charts.vue";
export default {
  components: {
    manage,
    charts,
    addUser,
    addBtn,
    dialogConfirm,
  },
  data() {
    return {
      nameRules: [
        (v) => !!v || this.lang.name_required,
        (v) => (v && v.length >= 3) || "Min 3 characters",
      ],
      addDialog: false,
      headers: [],
      allusers: [],
      players: {},
      search: "",
      manageEmail: "",
      pageLoading: true,
      manageDialog: false,
      chartsDialog: false,
      x: null,
      y: "top",
      mode: "",
      timeout: 3000,
      showAlert: false,
      color: "",
      icon: "",
      alertMessage: "",
      deleteConfirm: false,
      currentUserId: "",
    };
  },

  computed: {
    ...mapState(["lang", "fb", "adminUser"]),
  },
  methods: {
    confirmUserDelete(id) {
      this.deleteConfirm = true;
      this.currentUserId = id;
    },
    updateUser(user) {
      users.update(user.Email, user.name, user.accountName);
    },
    deleteUser() {
      this.pageLoading = true;
      users.del(this.currentUserId);
      this.currentUserId = "";
      this.deleteConfirm = false;
    },
    refreshUsers() {
      users.getUsers();
    },
    openUser(email) {
      this.manageEmail = "";

      this.manageEmail = email;
      this.manageDialog = true;

      //this.$router.push({ path: "/playlists/" + this.type + "/" + item.id });
    },
    copyToClipboard(text) {
      var input = text;
      input.select();
      document.execCommand("copy");
    },
    showSnackBar(color, icon, msg) {
      this.color = color;
      this.showAlert = true;
      this.icon = icon;
      this.alertMessage = msg;
    },
    onCopy() {
      this.showSnackBar(
        "green lighten-1",
        "check",
        this.lang.email + " " + this.lang.copied
      );
    },
    onError() {
      ths.showSnackBar("red lighten-1", "error", this.lang.error);
    },
    viewCharts() {
      this.chartsDialog = true;
    },
  },
  mounted() {
    this.headers = [
      { text: this.lang.email, value: "Email" },
      { text: this.lang.status, value: "status", align: "center" },
      {
        text: this.lang.account_name,
        value: "accountName",
        align: "center",
      },
      {
        text: this.lang.user_country,
        value: "location.country_name",
        align: "center",
      },
      { text: this.lang.registered_players, value: "players", align: "center" },
      {
        text: this.lang.online_offline,
        value: "onlinePlayers/offlinePlayers",
        align: "center",
      },
      {
        text: this.lang.user_no_licenses,
        value: "offlinePlayers",
        align: "center",
      },
      { text: "", value: "delete", align: "center" },
    ];
    var breadcrumb = {};
    breadcrumb.title = this.lang.users;
    var me = this;

    breadcrumb.items = [
      {
        title: this.lang.dashboard,
        action: function() {
          me.$router.push({ path: "/dashboard" });
        },
      },
    ];
    this.$store.commit("breadcrumb", breadcrumb);

    users.init(this);
  },
};
</script>
<style>
.v-chip.paid {
  background: lightcoral;
}
.v-chip.free {
  background: lightseagreen;
}
.no-uppercase {
  text-transform: none;
}
</style>
